import { I18n } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import { parseMDX } from "lib/mdx"
import LegalScene from "scenes/LegalScene"
import common from "../../i18n/pt/common"
import markdown from "../../i18n/pt/legal/privacy.md"

export default function PoliticaPrivacidade({ content }) {
  return (
    <I18n locale="pt" phrases={{ ...common }}>
      <LegalScene page="privacy" markdown={content} />
    </I18n>
  )
}

PoliticaPrivacidade.propTypes = {
  content: PropTypes.string.isRequired
}

export async function getStaticProps() {
  const parsedMdx = await parseMDX(markdown)
  return { props: { content: parsedMdx } }
}
